import React, { useEffect, useState } from 'react'
import { TimerContext } from 'src/contexts/TimerContext'
import ym from "react-yandex-metrika"
import { Outlet, useNavigate } from "react-router"
import { useSessionContext } from "src/hooks"

const TimerProvider = () => {
    const [currentTime, setCurrentTime] = useState<number>(5)
    const [timerStatus, setTimerStatus] = useState<boolean>(false)
    const { currentRound, setNextRound, currentCompany } = useSessionContext()
    const navigate = useNavigate()

    const turnOnTimer = () => {
        setTimerStatus(true)
    }

    const turnOffTimer = () => {
        setTimerStatus(false)
    }

    useEffect(() => {
        if (!timerStatus) return
        if (currentTime > 0) {
            const interval = setInterval(() => {
                setCurrentTime((prev) => prev - 1)
            }, 1000)
            return () => {
                clearInterval(interval)
            }
        } else {
            switch (currentRound) {
                case 0:
                    ym('reachGoal', 'first-round-passed')
                    break
                case 1:
                    ym('reachGoal', 'second-round-passed')
                    break
                case 2:
                    ym('reachGoal', 'third-round-passed')
                    break
                case 3:
                    ym('reachGoal', 'fourth-round-passed')
                    break
                case 4:
                    ym('reachGoal', 'fifth-round-passed')
                    break
            }
            ym('reachGoal', `${currentCompany}-round-passed`)
            navigate("/mid-game")
            setNextRound()
            setTimerStatus(false)
            setCurrentTime(5)
        }
    }, [currentTime, timerStatus])

    return (
        <TimerContext.Provider
            value={{
                currentTime,
                timerStatus,
                turnOnTimer,
                turnOffTimer,
            }}
        >
            <Outlet/>
        </TimerContext.Provider>
    )
}

export default TimerProvider